import { render, staticRenderFns } from "./modal-preview.vue?vue&type=template&id=2a3c9520&"
import script from "./modal-preview.vue?vue&type=script&lang=ts&"
export * from "./modal-preview.vue?vue&type=script&lang=ts&"
import style0 from "./modal-preview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports